<template>
  <div class="navigation-search__filters">
    <RouterLink
      :to="getKeywordQuery()"
      class="navigation-search__tags tag -light"
      :class="{ '-active': !currentKeywords.length }"
      replace
      exact
    >
      Aucun mot-clé
    </RouterLink>

    <RouterLink
      v-for="keyword in displayKeywords"
      :key="keyword.id"
      :to="getKeywordQuery(keyword.slug)"
      class="navigation-search__tags tag -light"
      :class="{ '-active': currentKeywords.includes(keyword.slug) }"
      replace
      exact
    >
      {{ keyword.name }}
    </RouterLink>

    <button
      v-if="restKeywords.length > 0"
      class="navigation-search__tags tag -light -icon-only"
      title="Montrer plus de mots-clés"
      aria-label="Montrer plus de mots-clés"
      @click="isModalOpen = true"
    >
      <SvgIcon id="plus" />
      <span v-if="restSelectedCount > 0" class="tag__count">{{ restSelectedCount }}</span>
    </button>

    <!-- eslint-disable-next-line vuejs-accessibility/click-events-have-key-events -->
    <div v-if="isModalOpen" class="modal" @click="isModalOpen = false">
      <section class="modal__box" @click.stop>
        <header class="modal__header">
          <div class="modal__hgroup">
            <h2 class="modal__title">Mots-clés</h2>

            <RouterLink
              v-if="currentKeywords.length > 0"
              :to="getKeywordQuery()"
              class="button -transparent -slim -error"
              :class="{ '-active': !currentKeywords.length }"
              replace
              exact
            >
              Tout désélectionner
            </RouterLink>
          </div>

          <button
            class="button -transparent -icon-only"
            title="Fermer la fenêtre modale"
            aria-label="Fermer la fenêtre modale"
            @click="isModalOpen = false"
          >
            <SvgIcon id="close" />
          </button>
        </header>

        <section class="modal__content">
          <ScrollBox content-class="navigation-search__filters -padded-bottom">
            <RouterLink
              v-for="keyword in displayKeywords"
              :key="keyword.id"
              :to="getKeywordQuery(keyword.slug)"
              class="navigation-search__tags tag -light"
              :class="{ '-active': currentKeywords.includes(keyword.slug) }"
              replace
              exact
            >
              {{ keyword.name }}
            </RouterLink>

            <RouterLink
              v-for="keyword in restKeywords"
              :key="keyword.id"
              :to="getKeywordQuery(keyword.slug)"
              class="navigation-search__tags tag -light"
              :class="{ '-active': currentKeywords.includes(keyword.slug) }"
              replace
              exact
            >
              {{ keyword.name }}
            </RouterLink>
          </ScrollBox>
        </section>

        <footer class="modal__footer">
          <button class="button -secondary" @click="isModalOpen = false">Appliquer les mots-clés</button>
        </footer>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KeywordPickerQuery',
  props: {
    dataset: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      isModalOpen: false
    }
  },
  computed: {
    keywordsWithMatches() {
      if (!this.dataset) return this.$wp.keywordsWithMatches

      return Object.values(this.$wp.keywords).reduce((acc, keyword) => {
        const hasMatch = this.dataset.some(({ keywords }) => keywords && keywords.includes(keyword.id))
        return hasMatch ? [...acc, keyword] : acc
      }, [])
    },
    currentKeywords() {
      if (!this.$route.query.keywords) return []
      return Array.isArray(this.$route.query.keywords) ? this.$route.query.keywords : [this.$route.query.keywords]
    },
    displayKeywords() {
      return this.keywordsWithMatches.filter(keyword => keyword.level === 'tag').slice(0, 10)
    },
    restKeywords() {
      const { tag, short, long } = this.keywordsWithMatches.reduce(
        (acc, keyword) => {
          if (acc[keyword.level]) acc[keyword.level].push(keyword)
          return acc
        },
        { tag: [], short: [], long: [] }
      )

      return [...tag.slice(10), ...short, ...long]
    },
    restSelectedCount() {
      return this.restKeywords.filter(keyword => this.currentKeywords.includes(keyword.slug)).length
    }
  },
  watch: {
    isModalOpen(isOpen, wasOpen) {
      if (isOpen === wasOpen) return

      if (isOpen) {
        this.$scroll.prevent()
      } else {
        this.$scroll.restore()
      }
    }
  },
  methods: {
    getKeywordQuery(slug) {
      const { page, keywords, ...queryRest } = this.$route.query
      if (!slug) return { query: queryRest }

      const newKeywords =
        slug && this.currentKeywords.includes(slug)
          ? this.currentKeywords.filter(key => key !== slug)
          : [...this.currentKeywords, slug]

      const query = !slug || newKeywords.length === 0 ? queryRest : { ...queryRest, keywords: newKeywords }
      return { query }
    }
  }
}
</script>
